import { CacheProvider } from '@emotion/react';
import { ReactNode } from 'react';
import { createEmotionCache } from '@/utils/emotionCache';
import { createJssWithNonce, JssProvider } from '@/utils/jssSetup';

// Create Emotion cache with CSP nonce for Material-UI styles
const emotionCache = createEmotionCache();

// Create JSS instance with CSP nonce support
const jss = createJssWithNonce();

interface CspProviderProperties {
  readonly children: ReactNode;
}

/**
 * Provider component that wraps the app with CSP-compliant style providers
 * Handles both JSS and Emotion cache configuration with nonce support
 */
export function CspProvider({ children }: CspProviderProperties) {
  return (
    <JssProvider jss={jss}>
      <CacheProvider value={emotionCache}>{children}</CacheProvider>
    </JssProvider>
  );
}
